/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_OverdueInputs */



/**
* | output |
* | --- |
* | "This term began {date} and is still unapproved. The customer cannot sign in." |
*
* @param {Partner_Org_Contract_OverdueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_overdue = /** @type {((inputs: Partner_Org_Contract_OverdueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_OverdueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Laufzeit begann am ${i?.date} und ist weiterhin nicht freigegeben. Der Kunde kann sich nicht anmelden.`)
	return /** @type {LocalizedString} */ (`This term began ${i?.date} and is still unapproved. The customer cannot sign in.`)
});